export default __webpack_public_path__ + "static/media/IconPlas.afc91eb8.svg";